var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "evaluateInterviewModal",
        tabindex: "-1",
        "data-backdrop": "static",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c("ValidationObserver", {
              ref: "evaluateInterviewRef",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("span", [_vm._v("面談評估")]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "modal-body" },
                        [
                          _c("div", { staticClass: "interview-result-list" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.approveInterviewResult.ApprovalResult,
                                    expression:
                                      "approveInterviewResult.ApprovalResult",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "result",
                                  value: "錄取",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.approveInterviewResult.ApprovalResult,
                                    "錄取"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.approveInterviewResult,
                                      "ApprovalResult",
                                      "錄取"
                                    )
                                  },
                                },
                              }),
                              _c(
                                "div",
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      name: "checkmark-circle-2-outline",
                                    },
                                  }),
                                  _c("span", [_vm._v("錄取")]),
                                ],
                                1
                              ),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.approveInterviewResult.ApprovalResult,
                                    expression:
                                      "approveInterviewResult.ApprovalResult",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "result",
                                  value: "考慮中",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.approveInterviewResult.ApprovalResult,
                                    "考慮中"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.approveInterviewResult,
                                      "ApprovalResult",
                                      "考慮中"
                                    )
                                  },
                                },
                              }),
                              _c(
                                "div",
                                [
                                  _c("eva-icon", {
                                    attrs: { name: "checkmark-circle-outline" },
                                  }),
                                  _c("span", [_vm._v("考慮中")]),
                                ],
                                1
                              ),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.approveInterviewResult.ApprovalResult,
                                    expression:
                                      "approveInterviewResult.ApprovalResult",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "result",
                                  value: "複試",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.approveInterviewResult.ApprovalResult,
                                    "複試"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.approveInterviewResult,
                                      "ApprovalResult",
                                      "複試"
                                    )
                                  },
                                },
                              }),
                              _c(
                                "div",
                                [
                                  _c("eva-icon", {
                                    attrs: { name: "edit-outline" },
                                  }),
                                  _c("span", [_vm._v("複試")]),
                                ],
                                1
                              ),
                            ]),
                            _c("label", { staticClass: "decline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.approveInterviewResult.ApprovalResult,
                                    expression:
                                      "approveInterviewResult.ApprovalResult",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "result",
                                  value: "不錄取",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.approveInterviewResult.ApprovalResult,
                                    "不錄取"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.approveInterviewResult,
                                      "ApprovalResult",
                                      "不錄取"
                                    )
                                  },
                                },
                              }),
                              _c(
                                "div",
                                [
                                  _c("eva-icon", {
                                    attrs: { name: "close-outline" },
                                  }),
                                  _c("span", [_vm._v("不錄取")]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm.approveInterviewResult.ApprovalResult === "錄取"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("是否確認基本資料 "),
                                    ]),
                                    _c("ValidationProvider", {
                                      ref: "backlistReason",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .approveInterviewResult
                                                          .ConfirmBasicCondition,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.approveInterviewResult,
                                                          "ConfirmBasicCondition",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "approveInterviewResult.ConfirmBasicCondition",
                                                    },
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "是",
                                                        value: true,
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "否",
                                                        value: false,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm.approveInterviewResult.ConfirmBasicCondition
                                  ? _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _vm._v("備註 "),
                                        ]),
                                        _c("ValidationProvider", {
                                          ref: "backlistReason",
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .approveInterviewResult
                                                              .InterviewBasicConditionGuid,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.approveInterviewResult,
                                                              "InterviewBasicConditionGuid",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "approveInterviewResult.InterviewBasicConditionGuid",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.AdmitOptions,
                                                        function (condition) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: condition.Guid,
                                                              attrs: {
                                                                label:
                                                                  condition.Name,
                                                                value:
                                                                  condition.Guid,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm.approveInterviewResult.ApprovalResult === "不錄取"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("不錄取原因 "),
                                    ]),
                                    _c("ValidationProvider", {
                                      ref: "backlistReason",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.rejectReasonGuid,
                                                      callback: function ($$v) {
                                                        _vm.rejectReasonGuid =
                                                          $$v
                                                      },
                                                      expression:
                                                        "rejectReasonGuid",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.Person.ResumeType ===
                                                      "IDL"
                                                      ? _vm.IdlRejectOptions
                                                      : _vm.DlRejectOptions,
                                                    function (reason) {
                                                      return _c("el-option", {
                                                        key: reason.Guid,
                                                        attrs: {
                                                          label: reason.Name,
                                                          value: reason.Guid,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("是否可再邀約 "),
                                    ]),
                                    _c("ValidationProvider", {
                                      ref: "backlistReason",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      disabled:
                                                        _vm.rejectReasonGuid ===
                                                          "00000000-0000-0000-0000-000000000000" ||
                                                        _vm.rejectReasonGuid ===
                                                          "11111111-1111-1111-1111-111111111111",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .approveInterviewResult
                                                          .CanInvitationAgain,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.approveInterviewResult,
                                                          "CanInvitationAgain",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "approveInterviewResult.CanInvitationAgain",
                                                    },
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "可再約",
                                                        value: true,
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "不可再約",
                                                        value: false,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm.rejectReasonGuid ===
                                  "00000000-0000-0000-0000-000000000000" ||
                                _vm.rejectReasonGuid ===
                                  "11111111-1111-1111-1111-111111111111"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _vm._v("備註 "),
                                        ]),
                                        _c("ValidationProvider", {
                                          ref: "backlistReason",
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.rejectNoteGuid,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.rejectNoteGuid =
                                                              $$v
                                                          },
                                                          expression:
                                                            "rejectNoteGuid",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.rejectNoteOptions,
                                                        function (note) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: note.Guid,
                                                              attrs: {
                                                                label:
                                                                  note.Name,
                                                                value:
                                                                  note.Guid,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _c("span", [_vm._v("其他備註")]),
                            ]),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.approveInterviewResult
                                      .ApprovalResultRemark,
                                  expression:
                                    "approveInterviewResult.ApprovalResultRemark",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                rows: "5",
                                maxlength: "100",
                              },
                              domProps: {
                                value:
                                  _vm.approveInterviewResult
                                    .ApprovalResultRemark,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.approveInterviewResult,
                                    "ApprovalResultRemark",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        2
                      ),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function ($event) {
                                return _vm.$store.commit(
                                  "OpenEvaluateInterviewModal",
                                  false
                                )
                              },
                            },
                          },
                          [_vm._v(" 關閉 ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.save)
                              },
                            },
                          },
                          [_vm._v(" 儲存 ")]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }